import { useState, useCallback, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { format } from 'date-fns';
import { CalendarViewMode, START_DATE_PARAM, VIEW_PARAM } from './types';
import { parsePageQueryParams } from './utils';

export function useSchedulerShiftsUrlSync() {
  const history = useHistory();

  const initialParams = useRef(
    parsePageQueryParams(new URLSearchParams(history.location.search)),
  ).current;

  const [currentDay, setCurrentDay] = useState(initialParams.date);
  const [mode, setMode] = useState<CalendarViewMode>(initialParams.mode);

  const updateUrl = useCallback(
    (newDate: Date, newMode: CalendarViewMode) => {
      const params = new URLSearchParams(history.location.search);
      const newDateStr = format(newDate, 'yyyy-MM-dd');
      const currentDateParam = params.get(START_DATE_PARAM);
      const currentViewParam = params.get(VIEW_PARAM);
      if (currentDateParam === newDateStr && currentViewParam === newMode) {
        return;
      }
      params.set(START_DATE_PARAM, newDateStr);
      params.set(VIEW_PARAM, newMode);
      history.replace({ search: params.toString() });
    },
    [history],
  );

  const handleDateChange = useCallback(
    (date: Date) => {
      setCurrentDay(date);
      updateUrl(date, mode);
    },
    [updateUrl, mode],
  );

  const handleModeChange = useCallback(
    (newMode: CalendarViewMode) => {
      setMode(newMode);
      updateUrl(currentDay, newMode);
    },
    [updateUrl, currentDay],
  );

  return {
    currentDay,
    mode,
    onDateChange: handleDateChange,
    onModeChange: handleModeChange,
  };
}
